import React, { useState, useRef, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import constants from '../../util/constants';
import { getShellActions } from '@nab/x-runtime';
import { H1, Paragraph, Modal, Form, Container, Row, Col, FormPassword, Button } from '@nab/nui-react';
import {
	ErrorBanner,
	ErrorScreenContainer,
	IconWrapper,
	ModalDataContainer
} from './ErrorScreen.style';
import ErrorIcon from './ErrorIcon'
import { debug } from '../../util/logger';

const ErrorScreen: React.FunctionComponent<{appConfig}> = ({appConfig}) => {

	const appActions = getShellActions();
	const [showError, setShowError] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showCookieDisabledContent, setShowCookieDisabledContent] = useState(false);
    const modelReference = useRef(null);

    const handleLoadEvent = (event:any) => {
	    if (event && !event.appLoaded) {
		    setShowError(true);
	    }
        setShowCookieDisabledContent(navigator && !navigator.cookieEnabled);
    };

    const handleKeepAlive = (event:any) => {
	    setShowModal(true);
    };

	useEffect(() => {
		debug(appConfig, 'subscribe to events');

		//Listening for app load
        appActions.addEventListener(constants.APP_SHELL_LOADED_EVENT, handleLoadEvent);

        //Listening for the app inactive event
        appActions.addEventListener(constants.APP_SHELL_KEEP_ALIVE_USER_INACTIVE, handleKeepAlive);

	}, []);

    const errorContent = () => (
        <>
            <ErrorScreenContainer>
                <ErrorBanner>
                    <IconWrapper>
                        <ErrorIcon/>
                    </IconWrapper>
                    <H1>{appConfig.errorPageTitle ? appConfig.errorPageTitle : 'Something went wrong'}</H1>
                    <Paragraph>{appConfig.errorPageMsg ? ReactHtmlParser(appConfig.errorPageMsg) : 'We couldn\'t load this page. Please try again later.'}</Paragraph>
                </ErrorBanner>
            </ErrorScreenContainer>
        </>
    );

    const maintenanceModeContent = () => (
        <>
            <ErrorScreenContainer>
                <ErrorBanner>
                    <IconWrapper>
                        <ErrorIcon/>
                    </IconWrapper>
                    <H1>{appConfig.maintenanceModeTitle}</H1>
                    <Paragraph>{ReactHtmlParser(appConfig.maintenanceModeMsg)}</Paragraph>
                    {appConfig.maintenanceModeButtonLabel && appConfig.maintenanceModeButtonLink &&
					<Button type="button" variant="primary" label={appConfig.maintenanceModeButtonLabel}
							onClick={() => {
                                location.href = appConfig.maintenanceModeButtonLink.startsWith('https://') ?
                                    appConfig.maintenanceModeButtonLink : appConfig.hostName + appConfig.maintenanceModeButtonLink;
                            }}/>
                    }
                </ErrorBanner>
            </ErrorScreenContainer>
        </>
    );

    const refreshPage = () => {
        window.location.reload(false);
    };

    const gridContent = () => (
        <>
            <Paragraph>
                {appConfig.sessionTimeoutNotificationMsg}
            </Paragraph>
            <Button type="button" variant="primary" label="Start again" onClick={() =>  refreshPage()}/>

        </>
    );

    const cookieDisabledContent = () => (
        <>
            <Paragraph>
                {appConfig.cookieDisabledNotificationMsg}
            </Paragraph>
            <Button type="button" variant="primary" label="Proceed after enabling cookies" onClick={() =>  refreshPage()}/>

        </>
    );

    return (
        <>
            <div ref={modelReference}>
            {appConfig.maintenanceMode && (
                maintenanceModeContent()
            )}

            {!appConfig.maintenanceMode && showError && (
                errorContent()
            )}

            {appConfig.sessionTimeoutNotification && showModal && (
                <Modal rootNode={modelReference.current} id={'id'} title={'Your session has expired'} alignment="middle">
                    <ModalDataContainer>
                        {gridContent()}
                    </ModalDataContainer>
                </Modal>
            )}

            {appConfig.cookieDisabledNotification && showCookieDisabledContent &&(
                <Modal rootNode={modelReference.current} id={'id'} title={'Browser cookies disabled'} alignment="middle">
                    <ModalDataContainer>
                        {cookieDisabledContent()}
                    </ModalDataContainer>
                </Modal>
            )}
            </div>
        </>
    );
};

export default ErrorScreen;
